import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskedLine } from "@/components/Reveal";

const PageHero = ({ kicker, titleLines, description, image, testId }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "20%"]);

  return (
    <section ref={ref} data-testid={testId} className="relative flex min-h-[62svh] items-end overflow-hidden">
      {image && (
        <motion.div style={{ y }} className="absolute inset-0 scale-110">
          <img src={image} alt="" className="h-full w-full object-cover" />
        </motion.div>
      )}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-obsidian" />
      <div className="relative z-10 mx-auto w-full max-w-7xl px-6 pb-20 pt-44 md:px-10">
        <p className="font-mono text-xs uppercase tracking-[0.35em] text-gold" data-testid={`${testId}-kicker`}>
          <MaskedLine delay={0.1}>{kicker}</MaskedLine>
        </p>
        <h1 className="mt-6 font-serif text-4xl font-medium leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-7xl">
          {titleLines.map((line, i) => (
            <MaskedLine key={line} delay={0.2 + i * 0.12}>
              {line}
            </MaskedLine>
          ))}
        </h1>
        {description && (
          <MaskedLine delay={0.55}>
            <p className="mt-8 max-w-2xl text-base leading-relaxed text-zinc-300 md:text-lg" data-testid={`${testId}-description`}>
              {description}
            </p>
          </MaskedLine>
        )}
      </div>
    </section>
  );
};

export default PageHero;
